import * as NavConstants from 'constants/NavConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import {defaultRequestsSearchParams} from 'requests/dashboard/RequestsSidepanel';
import {RouteBundle} from 'routing/RouteConstants';

export const RequestsRoutes: RouteBundle = {
  domain: 'requests',
  routes: [
    {urlPattern: 'requests', handler: requests, legacy: true},
    {urlPattern: 'requests/:requestId', handler: EditorRoutes.requestEditor.bind(EditorRoutes), legacy: true},
    {
      urlPattern: ':currentUserUrl/request-schemas/tasks/',
      handler: EditorRoutes.requestTaskSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/request-schemas/tasks/create',
      handler: EditorRoutes.requestTaskSchemaCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/request-schemas/tasks/:schemaId',
      handler: EditorRoutes.requestTaskSchema.bind(EditorRoutes),
      legacy: true,
    },
  ],
};

function requests(): void {
  EditorRoutes.sidepanelListing(NavConstants.SECTIONS.REQUESTS, defaultRequestsSearchParams());
}
